import classnames from 'classnames';
import { getTimeSpanFormattedValue } from 'components/shared/TimeSpanField/TimeSpanField.helper';
import { useLocale } from 'hooks/useLocale';
import { FC, useMemo } from 'react';

export interface TimeSpanFieldProps {
  className?: string;
  e2e?: string;
  id?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  value?: Nullable<string>;
  tabIndex?: number;
}

export const TimeSpanField: FC<TimeSpanFieldProps> = ({ className, e2e, id, size = 'md', value, tabIndex }) => {
  const [locale] = useLocale();

  const valueText = useMemo(() => {
    return getTimeSpanFormattedValue(value, locale);
  }, [locale, value]);

  return (
    <input
      className={classnames('text-field-component pe-none form-control', `form-control-${size}`, className)}
      data-e2e={e2e}
      readOnly
      disabled
      id={id}
      name={id}
      type="text"
      value={valueText}
      tabIndex={tabIndex}
    />
  );
};
